import { render, staticRenderFns } from "./SearchMSPointHistoryHeader.vue?vue&type=template&id=13e726f6&"
import script from "./SearchMSPointHistoryHeader.vue?vue&type=script&lang=js&"
export * from "./SearchMSPointHistoryHeader.vue?vue&type=script&lang=js&"
import style1 from "./SearchMSPointHistoryHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports